import { FC, memo } from 'react';

import Grid from '../../components/grid/Grid';
import { H2 } from '../../components/heading/Hx';
import Img from '../../components/img/Img';
import Paragraph from '../../components/paragraph/Paragraph';
import Route from '../../components/route/Route';
import Section from '../../components/section/Section';
import { COLOR } from '../../theme/type';

const Shop: FC = () => (
  <Section background={COLOR.Dark3}>
    <H2 center margin='0'>
      Starte Deinen Weg
    </H2>

    <Paragraph center margin={{ bottom: '2rem', top: '1rem' }}>
      Unsere Lehrvideos für die Grade S1-S4 ermöglichen Dir einen schnellen Einstieg.
    </Paragraph>

    <Grid columns={{ lg: 4, md: 2, xs: 1 }} spacing={{ lg: '1.25rem', xs: '1rem' }}>
      {[1, 2, 3, 4].map(idx => (
        <Grid.Centered key={idx}>
          <Route
            href={`https://shop.systema-berlin.de/product/s${idx}`}
            sx={{ display: 'block' }}
            underline={false}
          >
            <Img
              alt={`${idx}. Schülergrad`}
              src={`/img/poster-ranking-s${idx}.jpg`}
              sx={{ borderRadius: '0.25rem', maxWidth: '100%' }}
            />
          </Route>

          <Paragraph margin={{ y: { md: '0.75em', xs: '0.5em' } }}>
            <Route href={`https://shop.systema-berlin.de/product/s${idx}`} whiteSpace='normal'>
              {`Online Shop: ${idx}. Schülergrad`}
            </Route>
          </Paragraph>
        </Grid.Centered>
      ))}
    </Grid>
  </Section>
);

export default memo(Shop);
